import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { init as initApm } from '@elastic/apm-rum';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

initApmAgent();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

function initApmAgent() {
	try {
		if (environment.appConfig.isDev) return;
		console.debug('APM VERSION', window["APPVERSION"]);
		initApm({
			// Set custom APM Server URL (default: http://localhost:8200)
			serverUrl: environment.appConfig.apmServer,
			serviceName: 'tabit-pay',

			// Set the service version (required for source map feature)
			serviceVersion: window["APPVERSION"],

			// Set the service environment
			environment: environment.env
		});
	} catch (err) {
		console.debug('Error in initApmAgent');
	}

	console.debug('initApmAgent Occurred');
}
